<div class="col-md-12 clear-all " [ngClass]="{'margin-top-50 margin-left-40': (location === 'contentBottom')}">
  <div class="col-md-12 padding-right-0 " [ngClass]="{'text-left': (location === 'contentBottom'), 
     'text-right': (location === 'contentTop'),'padding-left-0': (location === 'contentBottom')}">
    <!-- <button id="saveProgress" name="saveProgress" (click)="saveProgress()" class="btn btn-tertiary btn-sm button" [ngClass]="{'clear-all': (location === 'contentTop')}"
  type="button">{{contentData.contentTopNavigationBar.saveProgress}}</button> -->

  <a [id]="'saveProgress_'+location" name="saveProgress" (click)="saveProgress()" tabindex="0" class="nav-btn pointer reflect-save opacity-50"
    [ngClass]="{'clear-all': (location === 'contentTop')}" (keyup.enter)="saveProgress()" aria-label="save Progress">
  {{saveProgressLabel}}</a>
</div>
<!-- <div *ngIf="router.url === '/user/list'" class="col-md-12 text-right btn-msg">
<small>This will take 5-10 mins</small>
</div> -->
@if (!saverAndReturnObj) {
  <div>
    @if (displayAlert) {
      <app-modal [modalConfig]="alertLoginModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
      (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="saveAlertWithoutLogin"></app-modal>
    }
  </div>
}
@if (isLocked) {
  <app-modal [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()" (primaryBtnClick)="closeLockedModal()"
    [saveDataFlag]="false">
  </app-modal>
}
</div>